import React from "react";

interface ChartHeaderProps {
  left: React.ReactNode;
  right?: React.ReactNode;
  children: React.ReactNode;
}

const ChartHeader: React.FC<ChartHeaderProps> = ({ left, right, children }) => {
  return (
    <div className="mb-2 block">
      <div className="flex items-center justify-between p-0 pb-4 md:pb-0">
        <div className="flex items-center gap-3">
          {/* Left - Image */}
          {left}

          {/* Center - Children (coin name and symbol) */}
          <div className="flex items-center gap-2">{children}</div>
        </div>

        {/* Right - Buttons */}
        <div className="overflow-visible">{right}</div>
      </div>
      <hr className="m-0 w-full border-0 border-b border-[#343537] md:hidden" />
    </div>
  );
};

export default ChartHeader;
